import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { formatTime } from '@blade/common/pages/crowd-queue-right/utils/index';
import lang from '@blade/common/pages/alert-details/lang/index';
import { HandlealAlarmType } from '@blade/common/store/alrm-type';
import detailsLevel from '@blade/common/pages/alert-details/components/details-level.vue';
let itemRight = class itemRight extends Vue {
    item;
    formatTime = formatTime;
    get deviceName() {
        return this.item?.deviceName || '-';
    }
    get matchTypeLibraryName() {
        if (this.item?.incidentType === 'FACE_MATCH') {
            return this.item?.faceAnnotation?.libraryName || '';
        }
        if (this.item?.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            return this.item?.pedestrianAnnotation?.libraryName || '';
        }
        if (this.item?.incidentType === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED' || this.item?.incidentType === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED') {
            return this.item?.automobileAnnotation?.libraryName || '';
        }
        return '';
    }
    get alerTypeMap() {
        return HandlealAlarmType.alarmTypeMap;
    }
    getDetailsIncidentType(val) {
        let newText = '';
        if (val.dateDiff && val.dateDiff > 0) {
            newText = this.$t('currentTime', { num: formatTime(val.dateDiff.toString()) }).toString();
        }
        return newText;
    }
};
__decorate([
    Prop()
], itemRight.prototype, "item", void 0);
itemRight = __decorate([
    Component({
        name: 'itemRight',
        components: {
            BlurPicture,
            detailsLevel,
        },
        i18n: {
            messages: lang,
        },
    })
], itemRight);
export default itemRight;
